import { types } from 'mobx-state-tree';

export const PolicyDetails = types.model('PolicyDetails', {
  code: types.string,
  name: types.string,
  details: types.maybe(types.string),
  isDefault: types.boolean,
  domesticDays: types.optional(types.union(types.number, types.string), ''),
  internationalDays: types.optional(types.union(types.number, types.string), ''),
});

export const PolicySetOptions = types.model('PolicySetOptions', {
  shipping: types.optional(types.array(PolicyDetails), []),
  payment: types.optional(types.array(PolicyDetails), []),
  returns: types.optional(types.array(PolicyDetails), []),
});
